import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  removeRefrence(data:any){
    return JSON.parse(JSON.stringify(data));
  }

  restrictCharacters(str){
    const invalidChars = ["<", ">", "~", "\\"];

    return invalidChars.includes(str);
  }

  scrollHeightCondition(){
    let isScrollAtBottom = false;
    const scrollY = window.scrollY + window.innerHeight + 2;
    const bodyScroll = document.body.offsetHeight;

    if (scrollY >= bodyScroll) {
      isScrollAtBottom = true;
    } else {
      isScrollAtBottom = false;
    }
    return isScrollAtBottom;
  }
}
